import { computeThirdPartyReviewsCount, getThirdPartyReviews } from '../center'
import { isNil, isObject } from '../../utils/checks'
export const computeNativeReviewsCount = (nativeReviews) => {
  return nativeReviews?.review_count ?? nativeReviews?.length ?? 0
}

export const computeNativeReviewsAverage = (nativeReviews) => {
  if (!Array.isArray(nativeReviews)) return null
  const nativeReviewsCount = computeNativeReviewsCount(nativeReviews)
  if (nativeReviewsCount === 0) return null

  const nativeReviewsSum = nativeReviews?.reduce((acc, review) => {
    return acc + review.overall_star
  }, 0)
  return nativeReviewsSum / nativeReviewsCount
}

export const computeAllReviewsCount = (center) => {
  if (isNil(center) || !isObject(center)) return 0
  return center.review_count + computeThirdPartyReviewsCount(center) || 0
}

export const computeAllReviewsWeightedAverage = (center) => {
  if (isNil(center) || !isObject(center)) return 0

  const thirdPartyReviews = getThirdPartyReviews(center)

  const { review_count, review_average } = center

  const nativeReviewsCount = review_count
  const nativeReviewsAverage = review_average || 0

  const totalReviewCount =
    nativeReviewsCount + computeThirdPartyReviewsCount(center)
  if (totalReviewCount === 0) return 0

  const nativeReviewsWeight = nativeReviewsCount * nativeReviewsAverage
  const totalWeight =
    thirdPartyReviews?.reduce((acc, review) => {
      return acc + review.review_count * review.rating
    }, nativeReviewsWeight) || nativeReviewsWeight

  return totalWeight / totalReviewCount
}
